import React, {useEffect, useState} from 'react';

import LetterboxContext from "./LetterboxContext";
import {getMyLetterbox} from "root/DataFunctions/LetterboxDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";

const LetterboxProvider = (props) => {

    const [ storedQueryData, setStoredQueryData ] = useState ( { child_uid: null, filter: null }) ;

    const [ letterboxData, setLetterboxData] = useState ( { isLoading: true, data : [] } ) ;

    const getMyLetterboxLocal = (child_uid, filter) =>
    {
        // Save for the refresh
        setStoredQueryData( { child_uid: child_uid, filter: filter }) ;

        getMyLetterbox( child_uid, filter, (response) =>
        {
            const data = getDataFromResponse(response);

            setLetterboxData({isLoading: false, data: data});
        })
    }

    return (
        <LetterboxContext.Provider
            value={{
                isLetterboxLoading: letterboxData.isLoading,
                letterboxData: letterboxData.data,
                getMyLetterbox: (child_uid, filter ) =>{
                    getMyLetterboxLocal(child_uid, filter );
                },
                refreshLetterbox: () =>{
                    getMyLetterboxLocal(storedQueryData.child_uid, storedQueryData.filter );
                },
            }}
        >
            {props.children}
        </LetterboxContext.Provider>
    )
}

export default LetterboxProvider;
